import React from 'react';

const Button = ({ children, variant = 'primary', size = 'md', className = '', disabled = false, onClick, type = 'button', ...props }) => {
  const variants = {
    primary: 'bg-brand-red text-white hover:bg-opacity-90',
    secondary: 'bg-white text-brand-dark border border-brand-border hover:bg-gray-50',
    outline: 'border border-brand-red text-brand-red bg-transparent hover:bg-brand-red hover:text-white',
    ghost: 'bg-transparent text-brand-dark hover:bg-gray-100',
    danger: 'bg-red-600 text-white hover:bg-red-700',
  };
  const sizes = { sm: 'px-3 py-1.5 text-sm', md: 'px-5 py-2 text-base', lg: 'px-6 py-3 text-lg' };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${variants[variant]} ${sizes[size]} font-medium rounded-pill transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-red focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;